
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import solrDescriptor from './DatasetManagementSolrDatasetDescriptor.json'
import restDescriptor from '../restDataset/DatasetManagementRestDatasetDescriptor.json'
import FacetInfoDialog from '../infoDialogs/DatasetManagementFacetInfoDialog.vue'
import RequestHeadersTable from '../tables/DatasetManagementRequestHeadersTable.vue'
import QueryParamTable from '../tables/DatasetManagementQueryParamTable.vue'
import Card from 'primevue/card'

export default defineComponent({
    components: { Card, KnValidationMessages, FacetInfoDialog, RequestHeadersTable, QueryParamTable },
    props: {
        parentValid: { type: Boolean },
        selectedDataset: { type: Object as any },
        dataSources: { type: Array as any },
        businessModels: { type: Array as any }
    },
    emits: ['touched'],
    data() {
        return {
            restDescriptor,
            solrDescriptor,
            dataset: {} as any,
            v$: useValidate() as any,
            facetQueryHelpVisible: false
        }
    },
    created() {
        this.dataset = this.selectedDataset
        if (this.dataset.dsTypeCd === 'Solr' && (!this.dataset.solrType || this.dataset.solrType === 'FACETS')) this.dataset.solrType = 'DOCUMENTS'
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
        }
    },
    validations() {
        const solrFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'Solr' || value
        }
        const documentFieldsRequired = (value) => {
            return this.dataset.solrType != 'DOCUMENTS' || value
        }
        const customValidators: ICustomValidatorMap = { 'solr-fields-required': solrFieldsRequired, 'document-fields-required': documentFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', solrDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {}
})
